"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
function ClientProfilePictureLoader(t0) {
  const $ = _c(6);
  const {
    size
  } = t0;
  const [isHydrated, setIsHydrated] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsHydrated(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (isHydrated) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== isHydrated || $[4] !== size) {
    t3 = <p className="bg-grey -mt-8 mb-8 animate-pulse rounded-full" style={!isHydrated ? {
      width: size,
      height: size
    } : {}} />;
    $[3] = isHydrated;
    $[4] = size;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default ClientProfilePictureLoader;